function enableClickDimensions() {
    // var cdAnalytics = new clickdimensions.Analytics('analytics.clickdimensions.com');
    // cdAnalytics.setAccountKey('aT4p1R2WGAEeq1zs5bJqDq');
    // cdAnalytics.setDomain('usnr.com');
    // cdAnalytics.setScore(typeof(cdScore) == 'undefined' ? 0 : (cdScore == 0 ? null : cdScore));
    cdAnalytics.trackPage();
}
